import { useIsSerialNumberTrackingPhase2Available } from './use-is-serial-number-tracking-phase-2-available';
import { useUserHasEditSerialNumbersRole } from '../hooks/use-user-role';

// Phase 2 OFF → always editable (backward-compat). Phase 2 ON → gated by Edit Serial Numbers role.
export const useCanEditSerialNumbers = (): boolean => {
  const isPhase2Available = useIsSerialNumberTrackingPhase2Available();
  const hasEditSerialNumbersRole = useUserHasEditSerialNumbersRole();
  return !isPhase2Available || hasEditSerialNumbersRole;
};
